import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bingtu",
  "use": "icon-bingtu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bingtu\"><defs><style type=\"text/css\"></style></defs><path d=\"M374.336 180.992a358.528 358.528 0 1 0 470.464 464.32h95.04a448 448 0 1 1-565.504-559.744v95.424z m89.6-114.432a448 448 0 0 1 493.952 489.152H464V66.56z m403.584 399.744a358.592 358.592 0 0 0-314.112-310.4v310.4h314.112z\" p-id=\"10278\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol